import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PlatformList from '../../campaign/campaignList/PlatformList.tsx';
import TicketsListAdmin from '../../ticket/TicketsListAdmin.tsx';
import { MdOutlineAccountBalanceWallet, MdOutlineCameraAlt, MdOutlineStarOutline } from 'react-icons/md';
import PaymentListTable from '../../../finance/PaymentListTable.tsx';

const TABS_ITEM = [
	{ text: 'campaigns', icon: <MdOutlineStarOutline className="size-4" /> },
	{ text: 'finance', icon: <MdOutlineAccountBalanceWallet className="size-4" /> },
	{ text: 'ticket', icon: <MdOutlineCameraAlt className="size-4" /> },
	// {text: 'شبکه اجتماعی', icon: <Group/>},
	// {text: 'شرکت ها', icon: <Group/>},
	// {text: 'درخواست ها', icon: <Group/>},
];

// todo add permission + another tabs
const UserProfile = () => {
	const { id } = useParams();
	const { t } = useTranslation();
	const [tab, setTab] = useState(0);

	return (
		<Box className={'w-full'}>
			<ul className="mb-4 flex flex-wrap text-center text-sm font-medium text-gray-500 dark:text-gray-400">
				{TABS_ITEM.map((i, index) => (
					<li className="me-2">
						<Box onClick={() => setTab(index)} className={`itmes-center flex cursor-pointer gap-2 px-4 py-3 ${index === tab ? 'active rounded-lg bg-primary-main text-white' : 'rounded-lg hover:bg-gray-100 hover:text-gray-900'}`} aria-current="page">
							<Box>{i.icon}</Box>
							<Typography>{t(i.text)}</Typography>
						</Box>
					</li>
				))}
			</ul>

			{tab === 0 ? <PlatformList adminId={id} /> : tab === 1 ? <PaymentListTable adminId={id} /> : tab === 2 ? <TicketsListAdmin adminId={id} /> : undefined}
		</Box>
	);
};

export default UserProfile;
